(function() {
angular.module('app.ui.form.ctrls')
.controller('JobEditCtrl', [
    'INHOUSE_CATEGORY', '$http', '$log', '$location', '$scope', 'sharedProperties', '$modal', 'usSpinnerService', 'logger', '$timeout', 
    function(INHOUSE_CATEGORY, $http, $log, $location, $scope, sharedProperties, $modal, usSpinnerService, logger, $timeout) {
      let cloneJob, updateJob;
      $scope.editorOptions = {
          extraPlugins: 'colorbutton'
      };
      $scope.jobID = $location.search().job;
      if ($location.search().isClone === "true")
        $scope.isCloneJob = true;
      else
        $scope.isCloneJob = false;       
      sharedProperties.verifyUser(_.range(11,18));

      function navigateBackToTheRespectiveListing(categoryId){
        $location.url('/admin/admin-listings?list=' + ((categoryId === INHOUSE_CATEGORY) ? 'inhouse-jobs' : 'jobs') );
      }

      $scope.startSpin = function() {
        if (!$scope.spinneractive && !$scope.recordFetched) {
          usSpinnerService.spin('spinner-2');
          $scope.spinneractive = true;
          $scope.startcounter++;
        }
      };
      $scope.stopSpin = function() {
        if ($scope.spinneractive) {
          usSpinnerService.stop('spinner-2');
          $scope.spinneractive = false;
        }
      };
      $scope.updatedJob = {
        pqe: "-2;11"
      };
      $scope.firms = [];
      $scope.jobPractices = [];
      $scope.practiceAreas = [];
      $scope.jobExp = [];
      $scope.showClass = "";
      $scope.hideDropDown = function() {
        $scope.showClass = "";
      };
      $scope.showDropDown = function() {
        if ($scope.showClass === "") {
          $scope.showClass = "show";
        } else {
          $scope.showClass = "";
        }
      };
      $scope.mapAddress = function() {
        $scope.firms.forEach(function(firm, index, array) {
          if (firm.user.firm_Name === $scope.updatedJob.firm.user.firm_Name) {
            $scope.updatedJob.jobCategory = 1;
            $scope.updatedJob.firmCategory = firm.refCategoryCatID;
            $scope.updatedJob.job_Address = angular.copy(firm.firm_Address);
          }
        });
      };
      $scope.getJobCategory = function() {
        if ($scope.updatedJob.is_custom) {
          $scope.updatedJob.jobCategory = "2";
        } else if ($scope.updatedJob.is_connected) {
          $scope.updatedJob.jobCategory = "3";
        } else if ($scope.updatedJob.isSpeculative) {
          $scope.updatedJob.jobCategory = "4";
        } else if ($scope.updatedJob.ATS_link) {
          $scope.updatedJob.jobCategory = "5";
        } else {
          $scope.updatedJob.jobCategory = "1";
        }
      };
      // $http.post('/api/get-edit-job', {
      //   'contentType': 'application/json'
      // }).then(function({data, status, headers, config}) {
      let getJobInformation = ()=>{
        $scope.startSpin('spinner-2');
        if ($scope.isCloneJob) {
          $scope.pageTitle = "Clone Job";
          $scope.actionTitle = "Clone";
        } else {
          $scope.pageTitle = "Edit Position";
          $scope.actionTitle = "Update";
        }
        $http.post('/api/job-firm-name', {
          'contentType': 'application/json'
        }).then(function({data, status, headers, config}) {
          $scope.populateFirms(data);
          $scope.stopSpin('spinner-2');
        },function({data,status}) {
          $log.info('error');
          $scope.changeStatus(status);
        });
        $http.post('/api/fetch-all-contracts', {
          'contentType': 'application/json'
        }).then(function({data, status, headers, config}) {
          $scope.refContracts = data;
        },function(data) {
          $log.info('error');
        });
        $http.post('/api/fetch-all-roles', {
          'contentType': 'application/json'
        }).then(function({data, status, headers, config}) {
          $scope.refRoles = data;
        },function(data) {
          $log.info('error');
        });

        $scope.locations = [];
        $http.post('/api/profile-practice-areas', {
          'contentType': 'application/json'
        }).then(function({data, status, headers, config}) {
          $scope.practiceAreas = data;
          $http.post('/api/fetch-job-practices', {
            id: $scope.jobID
          }).then(function({data, status, headers, config}) {
            $scope.jobPractices = data;
            $scope.updatedJob.practices = $scope.jobPractices;
            if ($scope.jobPractices.length > 0) {
              $scope.showTags = true;
            } else {
              $scope.showTags = false;
            }
            $scope.mapPractices();
          },function({data,status}) {
            if (status === 440) {
              $location.url('/signin');
            }
          });
        },function({data,status}) {
          $log.info('error');
          $scope.changeStatus(status);
        });
      }
      getJobInformation();
      // },function(data) {});
      $http.post('/api/fetchJobExp', {
        'contentType': 'application/json'
      }).then(function({data, status, headers, config}) {
        $scope.jobExp = data;
      },function(data) {});
      $scope.mapJobLocations = function() {
        return $scope.nrefLocations.forEach(function(loc, index, array) {
          $scope.jobLocations.forEach(function(uloc, index, array) {
            if (loc.loc_ID === uloc.loc_ID) {
              loc.isSelected = true;
            }
            return loc.locations.forEach(function(region_area, index, array) {
              $scope.jobLocations.forEach(function(rloc, index, array) {
                if (region_area.loc_ID === rloc.loc_ID) {
                  region_area.isSelected = true;
                }
                return region_area.sub_areas.forEach(function(sub_area, index, array) {
                  $scope.jobLocations.forEach(function(rloc, index, array) {
                    if (sub_area.loc_ID === rloc.loc_ID) {
                      return sub_area.isSelected = true;
                    }
                  });
                });
              });
            });
          });
        });
      };

      $scope.areasToShow = [];
      $scope.mapPractices = function() {
        $scope.jobPractices.forEach(function(job_area, index, array) {
          $scope.practiceAreas.forEach(function(area, index, array) {
            if (job_area.refPracticePracticeID === area.practice_ID) {
              area.isSelected = true;
            }
          });
        });
        $scope.practiceAreas.forEach(function(area, index, array) {
          $scope.areasToShow.push(area);
          if (area.law_area === null && area.practice_area === null) {
            area.practices = [];
            $scope.refPractices.push(area);
            $scope.practiceAreas.forEach(function(prac_area, index, array) {
              if (prac_area.law_area === area.practice_ID && prac_area.practice_area === null) {
                prac_area.sub_areas = [];
                area.practices.push(prac_area);
                $scope.practiceAreas.forEach(function(sub_area, index, array) {
                  if (sub_area.law_area !== null && sub_area.practice_area === prac_area.practice_ID) {
                    prac_area.sub_areas.push(sub_area);
                  }
                });
              }
            });
          }
        });
        $scope.jobPractices = angular.copy($scope.practiceAreas);
      };
      this.showOnSuccess = false;
      this.showOnError = false;
      $scope.curFirm = {};
      this.firmNames = [];
      $scope.locations = [];
      $scope.nrefLocations = [];
      this.alertMsg = '';
      $scope.minValue = -2;
      $scope.maxValue = 11;
      $scope.options = {
        round: 1,
        from: -2,
        to: 11,
        step: 1,
        dimension: "+ years",
        scale: [-2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, "11+"]
      };
      $scope.jobLastDateChanged = function() {
        return $scope.updatedJob.reopen_date = new Date();
      };
      $scope.pqeChange = function() {
        var seperator;
        seperator = $scope.updatedJob.pqe.search(";");
        if (seperator === 1) {
          $scope.updatedJob.min_pqe = parseInt($scope.updatedJob.pqe.slice(0, 1));
          $scope.updatedJob.max_pqe = parseInt($scope.updatedJob.pqe.slice(2, 5));
        } else if (seperator === 2) {
          $scope.updatedJob.min_pqe = parseInt($scope.updatedJob.pqe.slice(0, 2));
          $scope.updatedJob.max_pqe = parseInt($scope.updatedJob.pqe.slice(3, 5));
        }
      };
      $scope.visibleFirms = [];
      $scope.inVisibleFirms = [];
      $scope.populateFirms = function() {
        $scope.firms = _.sortBy($scope.firms, function(firm) {
          return -firm.firm_Visibility;
        });
        $scope.firms.forEach(function(firm, index, array) {
          if (firm.firm_Visibility) {
            firm.firm_Visibility = "VISIBLE FIRMS";
          } else {
            firm.firm_Visibility = "INVISIBLE FIRMS";
          }
          if (firm.firm_ID === $scope.updatedJob.firmFirmID) {
            $scope.curFirm.name = firm.firm_Name;
            $scope.curFirm.id = firm.firm_ID;
            $scope.updatedJob.firm = firm;
            return false;
          }
        });
      };
      $scope.mapFirms = function() {
        $scope.firms.forEach(function(firm, index, array) {
          firm.firm_Name = firm.user.firm_Name;
        });
        $scope.populateFirms();
      };
      $scope.openPracticeModal = function(event) {
        var modalInstance;
        event.preventDefault();
        event.stopPropagation();
        $scope.tempPractices = angular.copy($scope.refPractices);
        modalInstance = $modal.open({
          templateUrl: "SelectPracticesModal.html",
          controller: 'jobPracticesModalCtrl',
          resolve: {
            data: function() {
              return $scope.tempPractices;
            }
          }
        });
        return modalInstance.result.then((function(selectedItem) {
          var count;
          $scope.practiceAreas = angular.copy(selectedItem.linearPractices);
          count = 0;
          selectedItem.linearPractices.forEach(function(prac, index, array) {
            if (prac.isSelected) {
              count++;
            }
          });
          if (count > 0) {
            $scope.showTags = true;
          } else {
            $scope.showTags = false;
          }
          $scope.refPractices = angular.copy(selectedItem.data);
          $scope.updatedJob.practices = angular.copy(selectedItem.linearPractices);
          $scope.jobPractices = angular.copy(selectedItem.linearPractices);
        }), function() {
          $scope.tempPractices = {};
        });
      };
      $scope.openModal = function(event) {
        var id, modalInstance;
        id = event.target.attributes.id.value;
        $scope.modalData = {
          element: '',
          data: []
        };
        if (id === 'select-locations') {
          $scope.modalData.element = 'location';
          $scope.tempLocations = angular.copy($scope.nrefLocations);
          $scope.modalData.data = angular.copy($scope.tempLocations);
        } else if (id === 'select-practices') {
          $scope.modalData.element = 'practice';
          $scope.tempPractices = angular.copy($scope.refPractices);
          $scope.modalData.data = angular.copy($scope.tempPractices);
          $scope.modalData.linearPractices = angular.copy($scope.areasToShow);
        }
        modalInstance = $modal.open({
          templateUrl: "EditJobModal.html",
          controller: 'CreateProfileModalCtrl',
          resolve: {
            data: function() {
              return $scope.modalData;
            }
          }
        });
        return modalInstance.result.then((function(selectedItem) {
          var count;
          if (selectedItem.element === 'location') {
            $scope.nrefLocations = angular.copy(selectedItem.data);
            $scope.requestedData = {
              updated_data: angular.copy($scope.tempLocations)
            };
            count = 0;
            $scope.jobLocations = [];
            selectedItem.data.forEach(function(location, index, array) {
              if (location.isSelected) {
                $scope.jobLocations.push(location);
                location.locations.forEach(function(loc, index, array) {
                  if (loc.isSelected) {
                    $scope.jobLocations.push(loc);
                    count++;
                    loc.sub_areas.forEach(function(sub, index, array) {
                      if (sub.isSelected) {
                        $scope.jobLocations.push(sub);
                        count++;
                      }
                    });
                  }
                });
              }
            });
            if (count > 0) {
              $scope.editLocations = true;
            } else {
              $scope.editLocations = false;
            }
          } else if (selectedItem.element === 'practice') {
            $scope.tempPractices = angular.copy(selectedItem.data);
            $scope.requestedData = {
              currentLawyer: $scope.loggedInLawyer.lawyer.lawyer_ID,
              updated_data: angular.copy($scope.tempPractices),
              linearPractices: angular.copy(selectedItem.linearPractices)
            };
            $scope.selectPractices($scope.requestedData);
          }
        }), function() {
          $scope.tempLocations = {};
          $scope.tempPractices = {};
        });
      };
      $scope.changeStatus = function(status) {
        if (status === 200) {
          this.alertMsg = 'Congratulations! Job has been Successfully created.';
          this.showOnSuccess = true;
        } else if (status === 440) {
          $location.url('/signin');
        } else {
          this.alertMsg = 'An error has occurred. Please try again.';
          this.showOnError = true;
        }
      };
      this.logOut = function() {
        sharedProperties.logOut();
      };
      this.editJob = function() {
        if ($scope.updatedJob.job_description === null) {
          $scope.updatedJob.job_description = "";
        }
        if ($scope.isCloneJob) {
          cloneJob();
        } else {
          updateJob();
        }
      };
      this.cancelEditing = function() {
        navigateBackToTheRespectiveListing($scope.updatedJob.firm.refCategoryCatID);
      };
      cloneJob = function() {
        var message;
        $scope.setJobCategory();
        if ($scope.showTags && $scope.editLocations) {
          $http.post('/api/admin/cloneJob', $scope.updatedJob).then(function({data, status, headers, config}) {
            var message;
            message = 'Job cloned successfully.';
            logger.notify('success', message);
            navigateBackToTheRespectiveListing($scope.updatedJob.firm.refCategoryCatID);
          },function(data) {
            var message;
            $log.info('error');
            message = 'An error has occurred. Please try again.';
            logger.notify('error', message);
          });
          return;
        } else {
          if (!$scope.editLocations) {
            message = "Please select at least one Location.";
            logger.notify("error", message);
          }
          if (!$scope.showTags) {
            message = "Please select at least one practice area.";
            logger.notify("error", message);
          }
        }
      };
      $scope.setJobCategory = function() {
        $scope.updatedJob.location = $scope.jobLocations;
        if ($scope.updatedJob.jobCategory === "2") {
          $scope.updatedJob.is_custom = true;
          $scope.updatedJob.is_connected = false;
          $scope.updatedJob.isSpeculative = false;
          $scope.updatedJob.ATS_link = null;
        }
        if ($scope.updatedJob.jobCategory === "3") {
          $scope.updatedJob.is_connected = true;
          $scope.updatedJob.is_custom = false;
          $scope.updatedJob.isSpeculative = false;
          $scope.updatedJob.ATS_link = null;
        }
        if ($scope.updatedJob.jobCategory === "4") {
          $scope.updatedJob.isSpeculative = true;
          $scope.updatedJob.is_connected = false;
          $scope.updatedJob.is_custom = false;
          $scope.updatedJob.ATS_link = null;
        }
        if ($scope.updatedJob.jobCategory === "1") {
          $scope.updatedJob.isSpeculative = false;
          $scope.updatedJob.is_connected = false;
          $scope.updatedJob.is_custom = false;
          $scope.updatedJob.ATS_link = null;
        }
        if ($scope.updatedJob.jobCategory === "5") {
          $scope.updatedJob.isSpeculative = false;
          $scope.updatedJob.is_connected = false;
          $scope.updatedJob.is_custom = false;
        }
      };
      updateJob = function() {
        var message;
        $scope.setJobCategory();
        if ($scope.showTags && $scope.editLocations) {
          $http.post('/api/admin/updateJob', $scope.updatedJob).then(function({data, status, headers, config}) {
            $scope.startSpin('spinner-2');
            $timeout(function () {
              $scope.stopSpin('spinner-2');
              var message;
              message = 'Job edited successfully.';
              logger.notify('success', message);
              navigateBackToTheRespectiveListing($scope.updatedJob.firm.refCategoryCatID);
            },3000);
          },function(data) {
            var message;
            $log.info('error');
            message = 'An error has occurred. Please try again.';
            logger.notify('error', message);
          });
          return;
        } else {
          if (!$scope.editLocations) {
            message = "Please select at least one Location.";
            logger.notify("error", message);
          }
          if (!$scope.showTags) {
            message = "Please select at least one practice area.";
            logger.notify("error", message);
          }
        }
      };
      this.deleteJob = function() {
        var modalInstance;
        modalInstance = $modal.open({
          templateUrl: "deleteJobModal.html",
          controller: 'deleteJobModalCtrl',
          resolve: {
            data: function() {
              return $scope.jobID;
            }
          }
        });
        return modalInstance.result.then((function(selectedItem) {
          if (selectedItem) {
            $http.post('/api/admin/deleteJob', {
              id: $scope.jobID
            }).then(function({data, status, headers, config}) {
              $scope.changeStatus(status, 'delete');
              navigateBackToTheRespectiveListing($scope.updatedJob.firm.refCategoryCatID);
            },function({data,status}) {
              return $scope.changeStatus(status, '');
            });
          }
        }), function() {
          return;
        });
      };
      $scope.refPractices = [];
      $scope.populateAreas = function(data) {
        this.practiceAreas = data;
      };
      $scope.populateLocation = function(data) {
        data.forEach(function(loc, index, array) {
          if (loc.region === null && loc.area === null) {
            loc.locations = [];
            $scope.nrefLocations.push(loc);
            data.forEach(function(region_area, index, array) {
              if (region_area.region === loc.loc_ID && region_area.area === null) {
                region_area.sub_areas = [];
                loc.locations.push(region_area);
                data.forEach(function(sub_area, index, array) {
                  if (sub_area.region !== null && sub_area.area === region_area.loc_ID) {
                    region_area.sub_areas.push(sub_area);
                  }
                });
              }
            });
          }
        });
        $scope.refLocations = data;
      };

      const fetchAndMapRefLocations = () => {
        return $http.post('/api/profile-location', {
          'contentType': 'application/json'
        }).then(function({data, status, headers, config}) {
          $scope.locations = data;
          $scope.populateLocation(data);
        },function({data,status}) {
          $log.info('error');
          $scope.changeStatus(status);
        });
      };

      const getJobInfo = (jobId) => {
        $http
        .post('/api/admin/getJob', { id: jobId })
        .then(function ({data, status, headers, config}) {
          $scope.updatedJob = Object.assign($scope.updatedJob, data);
          $scope.updatedJob.pqe = data.job_min_pqe + ';' + data.job_max_pqe;
          $scope.updatedJob.last_date_to_apply= $scope.updatedJob.last_date_to_apply ? new Date($scope.updatedJob.last_date_to_apply) : $scope.updatedJob.last_date_to_apply;
          $scope.getJobCategory();
          $scope.jobLocations = $scope.updatedJob.ref_locations;
          $scope.jobLocations.forEach(function(loc, index, array) {
            return loc.isSelected = true;
          });
          $scope.mapJobLocations();
          if ($scope.jobLocations.length > 0) {
            $scope.editLocations = true;
          } else {
            $scope.editLocations = false;
          }
          $http.post('/api/admin/fetchAllFirms', {
            'contentType': 'application/json'
          }).then(function({data, status, headers, config}) {
            data.forEach(function(firm, index, array) {
              if (!firm.firm_isDeleted) {
                $scope.firms.push(firm);
              }
            });
            $scope.mapFirms();
          },function({data,status}) {
            $scope.changeStatus(status);
          });
        },function({data,status}) {
          $scope.changeStatus(status, '');
        });
      };

      (async function loadJobDetails(){
        await fetchAndMapRefLocations();
        getJobInfo($scope.jobID);
      })();
    }
  ]);
}());


// WEBPACK FOOTER //
// ./scripts/job/JobEditCtrl.js